goog.module('yext.entity.fields.LinkedAccount');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Select = goog.require('yext.location.Select');

/**
 * Linked account field
 *
 * @author MattJS (matt@yext.com)
 */
const LinkedAccount = class {
  /**
   * @param {!jQuery} $ctx Field element context
   */
  constructor($ctx) {
    this.$ctx = $ctx;
    this.$edit = $ctx.find('.js-entity-linked-account-edit').addBack()
      .filter('.js-entity-linked-account-edit');
    this.$fieldValue = this.$edit.find('.js-field-value');

    this.timestamp = this.$edit.data('timestamp');
    this.accounts = this.bindAccounts();

    this.storeValues();
    this.setFieldValue();
  }

  /**
   * Bind the individual accounts
   * @return {!Array.<LinkedAccount.Account>}
   */
  bindAccounts() {
    let accounts = [];
    this.$edit.find('.js-select-linked-account').each((idx, el) => {
      let account = new LinkedAccount.Account($(el));
      $(account).on('updated', () => {
        this.onUpdate();
      });
      accounts.push(account);
    });
    return accounts;
  }

  /**
   * Store the current values for linked accounts
   */
  storeValues() {
    this.accounts.forEach(account => {
      account.select.storeValue();
    });
  }

  /**
   * Reset accounts to their stored state
   */
  reset() {
    this.accounts.forEach(account => {
      account.select.reset();
    });
  }

  /**
   * Set the value of the field
   * @param {!Object} field Plain object version of the field
   */
  set(field) {
    let accountsByPartnerId = {};
    field['accounts'].forEach(account => {
      accountsByPartnerId[account['partnerId']] = account;
    });

    this.accounts.forEach(account => {
      let data = accountsByPartnerId[account.partnerId];
      account.select.set(data);
    });

    this.timestamp = field['timestamp'];
  }

  /**
   * Emit an update message and set the fields hidden input
   */
  onUpdate() {
    this.emitUpdate();
    this.setFieldValue();
  }

  /**
   * Emit a message indicating the field has been updated
   */
  emitUpdate() {
    $(this).trigger('updated');
  }

  /**
   * Set the fields hidden input to its JSON value
   */
  setFieldValue() {
    this.$fieldValue.val(yext.JSON.stringify(this.getData()));
  }

  /**
   * Get the field's data, keyed on strings
   */
  getData() {
    var accounts = [];
    this.accounts.forEach(account => {
      accounts.push(account.getData());
    });
    return {
      'timestamp': this.timestamp,
      'accounts': accounts,
    };
  }

  /**
   * @return {boolean} True if all accounts are empty
   */
  isEmpty() {
    for (var i = 0; i < this.accounts.length; i++) {
      if (!this.accounts[i].select.isEmpty()) {
        return false;
      }
    }
    return true;
  }

  /**
   * Get the display value for this field
   * @return {string}
   */
  getDisplayValue() {
    let html = '<table class="entity-linked-account-table">';
    this.accounts.forEach(account => {
      html += account.getDisplayValue();
    });
    html += '</table>';
    return html;
  }
};

/**
 * Single account in the compound linked account field
 *
 * @author MattJS (matt@yext.com)
 */
LinkedAccount.Account = class {
  constructor($ctx) {
    this.$ctx = $ctx;

    this.notLinkedTemplate = $ctx.find('.js-not-yet-linked-template').html();
    this.partnerId = $ctx.data('partnerId');
    this.brandName = $ctx.data('brandName');
    this.select = new Select($ctx);

    this.bind();
  }

  /**
   * Pass through updates from select
   */
  bind() {
    $(this.select).on('updated', () => {
      this.emitUpdate();
    });
  }

  /**
   * Emit a message indicating the account has been updated
   */
  emitUpdate() {
    $(this).trigger('updated');
  }

  /**
   * Get the account's data, keyed on strings
   */
  getData() {
    var data = this.select.getData();
    data['partnerId'] = this.partnerId;
    return data;
  }

  /**
   * @return {string} Display value as a table row for this account
   */
  getDisplayValue() {
    if (!this.select.hasOptions()) {
      return this.templateRow(this.notLinkedTemplate);
    } else if (this.select.isEmpty()) {
      return this.templateRow(
        '<span class="emptyvalue">' +
        yext.msg('Click to assign a {0} account', this.brandName) +
        '</span>');
    } else if (this.select.isIndeterminate()) {
      var various = '<span class="various">&lt;' + yext.msg('Multiple accounts') + '&gt;</span>';
      return this.templateRow(various);
    } else {
      return this.templateRow(this.select.getDisplayValue());
    }
  }

  templateRow(value) {
    return '<tr><td>' + this.brandName + '</td><td>' + value + '</td></tr>';
  }
};

exports = LinkedAccount;
